import { render, staticRenderFns } from "./ChangePhoneForm.vue?vue&type=template&id=6d1e588f&scoped=true&"
import script from "./ChangePhoneForm.vue?vue&type=script&lang=ts&"
export * from "./ChangePhoneForm.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePhoneForm.vue?vue&type=style&index=0&id=6d1e588f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e588f",
  null
  
)

export default component.exports